module.exports = __webpack_public_path__ + "media/images/logo_codolga-689fa1eade6f73c3b9ca04d973128d30.png";